import { render, staticRenderFns } from "./StatisticItem.vue?vue&type=template&id=2d0e0280&scoped=true&"
import script from "./StatisticItem.vue?vue&type=script&lang=js&"
export * from "./StatisticItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticItem.vue?vue&type=style&index=0&id=2d0e0280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e0280",
  null
  
)

export default component.exports